module.exports = __webpack_public_path__ + "img/9@3x.afda5139.png";